import { request } from "@/utils/request";
import store from "@/store";

/**
 * 查询
 * @param {*} data 
 * @returns 
 */
export function selectApi(data) {
  return request({
    url: `/admin/user/select`,
    method: "POST",
    data,
  });
}

/**
 * 新增
 * @param {*} data 
 * @returns 
 */
export function addApi(data) {
  return request({
    url: `/admin/user/add`,
    method: "POST",
    data,
  });
}

/**
 * 修改
 * @param {*} data 
 * @returns 
 */
export function updateApi(data) {
  return request({
    url: `/admin/user/update`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data 
 * @returns 
 */
export function deleteApi(data) {
  return request({
    url: `/admin/user/delete`,
    method: "POST",
    data,
  });
}

/**
 * 登录
 * @param {*} data 
 * @returns 
 */
export function loginApi(data) {
  return request({
    url: `/admin/user/login`,
    method: "POST",
    data,
  });
}


/**
 * 根据token查询用户信息
 * @param {*} data 
 * @returns 
 */
export function queryMyselfInfoApi(data) {
  return request({
    url: `/admin/user/queryMyselfInfo`,
    method: "POST",
    data,
  });
}


/**
 * 退出登录
 * @param {*} data 
 * @returns 
 */
/* 注销登录 */
export async function loginOutApi(data) {
  const resp = await request({
    url: "/admin/user/loginOut",
    method: "POST",
    data,
  });
  localStorage.removeItem("token"); //用户token
  store.commit("updataUserInfo", {}); //清除仓库信息
  store.commit("updataFilterNavList", []); //清除菜单信息
  store.commit("updataFilterStoreList", []); //清除门店权信息
  return resp;
}


/**
 * 修改自己的密码
 * @param {*} data 
 * @returns 
 */
export function updatePasswordApi(data) {
  return request({
    url: `/admin/user/updatePassword`,
    method: "POST",
    data,
  });
}
